import { axiosV2 } from 'interceptors/axios';
import { decryptResponse } from 'utils/token';

export const getOperationTypes = async (societyId: string) => {
  const query = { params: { societyId, distinct: 'operationType' } };
  try {
    const { data } = await axiosV2.get('/operations', query);

    const decodedData = await decryptResponse(data);

    return decodedData;
  } catch (error) {
    return [];
  }
};
